import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';
import { ArrowUpRight } from 'lucide-react';

interface GuidedEmptyAction {
  to: string;
  label: string;
  variant?: 'primary' | 'ghost';
}

export function GuidedEmpty({
  icon: Icon,
  title,
  body,
  action,
  secondaryAction,
  children,
}: {
  icon: LucideIcon;
  title: string;
  body: string;
  action?: GuidedEmptyAction;
  secondaryAction?: GuidedEmptyAction;
  children?: React.ReactNode;
}) {
  return (
    <div className="guided-empty">
      <div className="guided-empty__icon" aria-hidden>
        <Icon size={20} />
      </div>
      <div>
        <div className="guided-empty__title">{title}</div>
        <p className="guided-empty__body">{body}</p>
      </div>
      {children}
      {(action || secondaryAction) && (
        <div className="row guided-empty__actions">
          {action && (
            <Link to={action.to} className={`btn btn--${action.variant ?? 'primary'} btn--sm`}>
              {action.label} <ArrowUpRight size={13} />
            </Link>
          )}
          {secondaryAction && (
            <Link to={secondaryAction.to} className={`btn btn--${secondaryAction.variant ?? 'ghost'} btn--sm`}>
              {secondaryAction.label} <ArrowUpRight size={13} />
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
